import PrintTemplate from 'react-print'
import React, { Component } from 'react';
import ReactDOM from 'react-dom'
import {formatPrice} from '../helpers/helpers'
import {ref } from '../config/constants'

import QMainProductViewPrint from './QMainProductViewPrint'
import QBendedViewPrint from './QBendedViewPrint'
import QHardwareViewPrint from './QHardwareViewPrint'
import QMiscellaneousViewPrint from './QMiscellaneousViewPrint'


class Print extends Component{
	constructor(){
        super();        
        this.state={
            quotation : {},
            customer:{},
            labor : {}            
        }    
    }
    componentWillMount(){
        var number = parseInt(this.props.quoteNumber) - parseInt(1);

        let quotation = ref.child("Quotation").child(number);
            quotation.on("value", function(snap){
                this.setState({
                    quotation : snap.val(),
                    customer : snap.val().customer,
                    products : snap.val().products,
                    labor : snap.val().labor
                })
            }.bind(this)) 
    }
    render() {
        return (
            <PrintTemplate>
                <div className="mainWrapper">
                    <div className="forDateAndNumber">
                        <div className="qNumber">
                            <span>{this.state.quotation.quoteNumber}</span>
                        </div>
                        <div className="quoteDate">
                            <span>{this.state.quotation.quoteDate}</span>
                        </div>
                    </div>
                    <div className="wrapperHolder">
                        <div className="wrapperPrint">
                            <div className="leftHolder">
                                <span>{this.state.customer.name}</span>
                            </div>
                            <div className="rightHolder">
                                <span>{this.state.customer.number}</span>
                            </div>
                        </div>
                        <div className="clearfix"></div>

                        <div className="wrapperPrint">
                            <div className="leftHolder">
                                 <span>{this.state.customer.project}</span>
                            </div>
                            <div className="rightHolder">
                                <span>{this.state.customer.reference}</span>
                            </div>
                        </div>
                        <div className="clearfix"></div>

                        <div className="wrapperPrint">
                            <div className="leftHolder">
                                 <span>{this.state.customer.location}</span>
                            </div>
                            <div className="rightHolder">
                                <span>{this.state.customer.representative}</span>
                            </div>
                        </div>
                    </div>
                    <div className="clearfix"></div>
                    <div className="marginTop45px">
                        <table className="table tablePrint">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.products &&                                     
                                        Object.keys(this.state.products).map(function (key){
                                            let list = this.state.products[key]
                                            
                                            if(list.category ==="Main Product"){                                                   
                                                        //console.log(list)
                                                        return <QMainProductViewPrint key={key} product={list}/>                                                  
                                                       }

                                            if(list.category ==="Bended Accessories"){                                                   
                                                //console.log(list)
                                                return <QBendedViewPrint key={key} product={list}/>                                                  
                                               }                                                   
                                               
                                        }.bind(this))
                                }
                                <tr>                                    
                                    <td className="pName"></td>
                                    <td className="pDimension"></td>
                                    <td className="pQtyPUnit"></td>
                                    <td className="pPricePunit"></td>
                                    <td className="pDisc">Subtotal</td>                                    
                                    <td className="pAmount">{formatPrice(this.state.quotation.totalValue) && formatPrice(this.state.quotation.totalValue)}</td>
                                </tr>
                                
                            </tbody>
                        </table>
                        <table className="table tablePrint">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.products &&                                     
                                            Object.keys(this.state.products).map(function (key){
                                                let list = this.state.products[key]
                                                
                                                if(list.category ==="Hardware Accessories"){                                                   
                                                    //console.log(list)
                                                    return <QHardwareViewPrint key={key} product={list}/>                                                  
                                                   }

                                                if(list.category ==="Miscellaneous"){                                                   
                                                    //console.log(list)
                                                    return <QMiscellaneousViewPrint key={key} product={list}/>                                                  
                                                   }
                                                                                        
                                                   
                                            }.bind(this))

                                }
                                <tr>                                    
                                    <td className="pName"></td>
                                    <td className="pDimension"></td>
                                    <td className="pQtyPUnit"></td>
                                    <td className="pPricePunit"></td>
                                    <td className="pDisc">Subtotal</td>                                    
                                    <td className="pAmount">{formatPrice(this.state.quotation.totalValue2) && formatPrice(this.state.quotation.totalValue2)}</td>
                                </tr>
                                
                            </tbody>
                        </table>
                    </div>
                    <div className="totalHolder">
                        <table className="table tablePrint">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>                         
                                <tr >
                                    <td className="pName"></td>
                                    <td className="pDimension"></td>                                                                    
                                    <td colSpan={3}>Total Materials</td>
                                    <td className="pAmount2">{formatPrice(this.state.quotation.totalMaterials) && formatPrice(this.state.quotation.totalMaterials)}</td>
                                </tr>
                                <tr>
                                    <td className="pName"></td>
                                    <td className="pDimension"></td>                                                                    
                                    <td colSpan={3}>Delivery Cost</td>
                                    <td className="pAmount2">{formatPrice(this.state.quotation.deliveryCharge) && formatPrice(this.state.quotation.deliveryCharge)}</td>
                                </tr>
                                <tr>
                                    <td className="pName"></td>
                                    <td className="pDimension"></td>                                    
                                    <td colSpan={3}>Total Quotation</td>
                                    <td className="pAmount2">{formatPrice(this.state.quotation.totalQuote) && formatPrice(this.state.quotation.totalQuote)}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="consignee">
                        <div className="salesRep">
                            <span><p>{this.state.customer.representative}</p></span>
                        </div>
                        <div className="areaManager">
                            <span><p>Jason Solinap</p></span>
                        </div>
                    </div>
                </div>
                
            </PrintTemplate>
        );
    }
};

export default Print;


// WEBPACK FOOTER //
// ./src/components/Print.js